var _path, _g, _rect, _rect2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.627 67.918C142.627 115.46 81.502 156.21 81.502 156.21C81.502 156.21 20.377 115.46 20.377 67.918C20.377 51.7066 26.8169 36.1592 38.28 24.6961C49.7432 13.2329 65.2906 6.79297 81.502 6.79297C97.7133 6.79297 113.261 13.2329 124.724 24.6961C136.187 36.1592 142.627 51.7066 142.627 67.918Z",
    fill: "#ED801B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.6,
    cy: 67.9555,
    rx: 57.0395,
    ry: 57.0395,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.748,
    y: 19.1035,
    width: 97.5023,
    height: 97.5023,
    rx: 48.7511
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.748,
    y: 19.1035,
    width: 97.5023,
    height: 97.5023,
    rx: 48.7511,
    fill: "#ED801B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 138.5,
    r: 4.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.190f1a6b.svg";
export { ForwardRef as ReactComponent };